export default {
  'dashboard': ['dashboard_management']
}
